import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-pill border px-2.5 py-0.5 text-[13px] leading-[18px] font-body font-bold transition-colors focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-purple-500 text-white shadow hover:bg-purple-600",
        secondary:
          "border-transparent bg-purple-50 text-purple-700 hover:bg-purple-50",
        destructive:
          "border-transparent bg-danger text-white shadow hover:bg-danger/90",
        outline: "border-line text-ink bg-white",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
